import React from 'react';
import { Typography, Layout, Tabs, Row, message } from 'antd';
import NavigationForm from './forms/NavigationForm';
import IndexForm from './forms/IndexForm';
import LogViewer from './LogViewer';
import './Settings.css';
import { Modal } from 'antd';
import { authenticationUtils } from '../../../utils/common';
import { publishConfig } from '../../../config/env';

const { Header, Content } = Layout;
const { Title } = Typography;
const { TabPane } = Tabs;
const { confirm } = Modal;

const Settings = props => {
    let pathToSearchIndex = props.location.pathname.split("removeSearchIndex")[1]
    if (pathToSearchIndex !== undefined) {
        confirm({
            title: "Are you sure you'd like to remove " + pathToSearchIndex + "?",
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            cancelType: 'default',

            onOk: async () => {
                const res = deleteSearchIndex(pathToSearchIndex);
                res ? message.success("search index deleted succesfully") : message.error("something went wrong")
            }
        });
    }

    return (
        <Layout className="layout">
            <Header className="header" style={{ background: 'none', padding: 0 }}>
                <Row type="flex" justify="space-between">
                    <Title level={1} className="pageTitle">
                        Settings
                    </Title>
                </Row>
            </Header>
            <Content className="content">
                <Tabs defaultActiveKey="1" size="large">
                    <TabPane tab="Content" key="1">
                        <NavigationForm />
                        <IndexForm />
                    </TabPane>
                    <TabPane tab="Logging" key="2">
                        <LogViewer />
                    </TabPane>
                </Tabs>
            </Content>
        </Layout>
    );
};

const deleteSearchIndex = async pathToDelete => {
    const token = await authenticationUtils.getUserToken().then(token => {
        return token;
    });
    return await fetch(publishConfig.deleteSearchIndexUrl, {
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + token,
            'access-control-allow-origin': '*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ path: pathToDelete })
    })
        .then(res => {
            return res.status === 200
        })
        .catch((e) => {
            console.log(e)
            return false;
        });
};

export default Settings;
